// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../../assets/stylesheets/variables.css\"","body":"_2lYHSCAcM6vA2s-47YYZeS","body2":"_3SZbtBhXKsMgrIDYFmK8U","smallMaxWidth":"991px","primaryGreen":"#028154","questionText":"_3e1UtlPN64as2q5knej6dz _3SZbtBhXKsMgrIDYFmK8U","arrow":"_1TUG6N16YkjOeaKioFWXiN","answerText":"_1T13qMlF6sfw_VcPI9NEFX _2lYHSCAcM6vA2s-47YYZeS"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/product-detail/faq-section/faq/FAQ.css
// module id = 988
// module chunks = 1